import {
	COLLECTIONS_REQUESTS_LIST_INITIATED,
	COLLECTIONS_REQUESTS_LIST_LOADED,
	COLLECTIONS_REQUESTS_FAILED,

	COLLECTIONS_REQUESTS_COUNT_INITIATED,
	COLLECTIONS_REQUESTS_COUNT_LOADED,
	COLLECTIONS_REQUESTS_COUNT_FAILED,

	MERCHANT_COLLECTIONS_LIST_INITIATED,
	MERCHANT_COLLECTIONS_LIST_LOADED,
	MERCHANT_COLLECTIONS_LIST_FAILED
	
} from "../actions/MerchantCollectionsAction";

const initialState = {
	listdata: [],
	listDebitandLien: [],
	payoutCount: {
		credit_count: "0",
		total_credit: "0",
		debit_count: "0",
		total_debit: "0",
		total_count: "0",
		total_amount: "0",
	},
	pagination: {
		total: 0,
		page: 1,
		limit: 10,
		totalPages: 1,
		nextPage: null,
	},
	loading: false,
	error: null,
};

const MerchantPayoutAction = (state = initialState, action) => {
	switch (action.type) {
		case COLLECTIONS_REQUESTS_LIST_INITIATED:
			return {
				...state,
				loading: true,
				error: null,
			};
		case COLLECTIONS_REQUESTS_LIST_LOADED:
			return {
				...state,
				loading: false,
				listdata: action.payload.data,
				pagination: action.payload.pagination,
			};

		case COLLECTIONS_REQUESTS_COUNT_INITIATED:
			return { ...state };
		case COLLECTIONS_REQUESTS_COUNT_LOADED:
			return { 
				...state, payoutCount: {...action.payload, ...{
					total_count: parseFloat(action.payload.credit_count) + parseFloat(action.payload.debit_count),
					total_amount: parseFloat(action.payload.total_credit) - parseFloat(action.payload.total_debit)
				}},
				
			};
		case COLLECTIONS_REQUESTS_COUNT_FAILED:
			return { ...state };
			
		case MERCHANT_COLLECTIONS_LIST_INITIATED:
			return { ...state };
		case MERCHANT_COLLECTIONS_LIST_LOADED:
			return {
				...state,
				loading: false,
				listDebitandLien: action.payload.data,
				pagination: action.payload.pagination,
			};
		case MERCHANT_COLLECTIONS_LIST_FAILED:
			return { ...state };
		case COLLECTIONS_REQUESTS_FAILED:
			return { ...state, loading: false, error: action.payload };
		default:
			return state;
	}
};

export default MerchantPayoutAction;
